/* global SideDrawer */

if (!customElements.get('quick-add-drawer')) {
  class QuickAddDrawer extends SideDrawer {
    constructor() {
      super();
      this.content = this.querySelector('.js-product-details');
      this.footer = this.querySelector('.drawer__footer');
      this.form = this.querySelector('product-form');
      this.quickOrderList = this.querySelector('.js-quick-order-list');
      this.notification = this.querySelector('.js-added-to-cart');
      this.backBtn = this.querySelector('.drawer__back-btn');
      this.openCartDrawerLinks = this.querySelectorAll('.js-open-cart-drawer');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.fetch = null;
      this.fetchedUrls = [];
      this.quickAddButtonMouseEnterHandler = this.handleQuickAddButtonMouseEnter.bind(this);
      this.documentClickHandler = this.handleDocumentClick.bind(this);

      document.addEventListener('click', this.documentClickHandler);
      this.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      this.addEventListener('on:quick-order-list:update', this.refreshQuickOrderList.bind(this));

      this.openCartDrawerLinks.forEach((link) => {
        link.addEventListener('click', this.handleOpenCartClick.bind(this));
      });

      if (theme.device.hasHover && theme.mediaMatches.md) {
        document.querySelectorAll('.js-quick-add').forEach((button) => {
          this.bindQuickAddButtonMouseEnter(button);
        });

        if ('MutationObserver' in window) {
          this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-quick-add').forEach((button) => {
                    this.bindQuickAddButtonMouseEnter(button);
                  });
                }
              });
              mutation.removedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-quick-add').forEach((button) => {
                    button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
                  });
                }
              });
            });
          });
          this.observer.observe(document.body, { childList: true, subtree: true });
        }
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
      document.querySelectorAll('.js-quick-add').forEach((button) => {
        button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      });
      if (this.observer) this.observer.disconnect();
    }

    bindQuickAddButtonMouseEnter(button) {
      if (!button.dataset.quickAddListenerAdded) {
        button.dataset.quickAddListenerAdded = 'true';
        button.addEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      }
    }

    handleQuickAddButtonMouseEnter(evt) {
      if (!this.fetchedUrls.includes(evt.target.dataset.productUrl)) {
        this.fetch = {
          url: evt.target.dataset.productUrl,
          promise: fetch(evt.target.dataset.productUrl)
        };
        this.fetchedUrls.push(evt.target.dataset.productUrl);
      }
    }

    handleOpenCartClick(evt) {
      if (this.cartDrawer) {
        evt.preventDefault();
        this.cartDrawer.open();
      } else if (window.location.pathname === theme.routes.cart) {
        evt.preventDefault();
        this.close();
      }
    }

    handleDocumentClick(evt) {
      if (!evt.target.matches('.js-quick-add')) return;

      if (this.cartDrawer && this.cartDrawer.ariaHidden === 'false') {
        const overlay = document.querySelector('.js-overlay.is-visible');
        if (overlay) overlay.style.transitionDelay = '200ms';
        this.cartDrawer.close();
        setTimeout(() => {
          this.backBtn.hidden = false;
          this.open(evt.target);
          if (overlay) overlay.style.transitionDelay = '';
        }, 200);
      } else {
        this.open(evt.target);
      }
    }

    handleVariantChange(evt) {
      let url = this.productUrl;
      if (evt.detail.variant) {
        const separator = this.productUrl.split('?').length > 1 ? '&' : '?';
        url += `${separator}variant=${evt.detail.variant.id}`;
      }
      this.querySelectorAll('.js-prod-link').forEach((link) => {
        link.href = url;
      });
    }

    async refreshQuickOrderList(evt) {
      if (evt.detail.productId === this.productId) {
        const qbQuickOrderList = this.querySelector('quick-order-list');
        this.fetch = {
          url: this.productUrl,
          promise: fetch(this.productUrl)
        };
        const response = await this.fetch.promise;
        if (response.ok) {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();
          const productEl = tmpl.content.querySelector('.js-product');
          const quickOrderList = productEl.querySelector('quick-order-list');
          if (quickOrderList && qbQuickOrderList) {
            qbQuickOrderList.innerHTML = quickOrderList.innerHTML;
          }
        }
        this.fetch = null;
        qbQuickOrderList.disableLoading();
      }
    }

    async open(opener) {
      opener.setAttribute('aria-disabled', 'true');
      if (this.notification) this.notification.hidden = true;

      if (
        this.productUrl
        && this.productUrl === opener.dataset.productUrl
        && (!this.quickOrderList || this.quickOrderList.innerHTML.length === 0)) {
        super.open(opener);
        if (opener.dataset.selectedColor) this.setActiveVariant(opener);
        opener.removeAttribute('aria-disabled');
        return;
      }

      this.productUrl = opener.dataset.productUrl;
      this.productId = opener.dataset.productId;
      this.content.innerHTML = '';
      this.quickOrderList.innerHTML = '';
      this.classList.add('is-loading');
      this.content.classList.add('drawer__content--out');
      this.footer.classList.add('drawer__footer--out');

      super.open(opener);

      if (!this.fetch || this.fetch.url !== opener.dataset.productUrl) {
        this.fetch = {
          url: opener.dataset.productUrl,
          promise: fetch(opener.dataset.productUrl)
        };
      }

      const response = await this.fetch.promise;
      if (response.ok) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();
        this.productEl = tmpl.content.querySelector('.cc-main-product .js-product');
        this.renderProduct(opener);
      }

      this.fetch = null;
      opener.removeAttribute('aria-disabled');
    }

    close() {
      super.close(() => {
        this.backBtn.hidden = true;
      });
    }

    renderProduct(opener) {
      const sectionId = this.productEl.dataset.section;
      this.productEl.innerHTML = this.productEl.innerHTML.replaceAll(sectionId, 'quickadd');

      const quickOrderList = this.productEl.querySelector('quick-order-list');
      if (quickOrderList) quickOrderList.setAttribute('data-section', sectionId);

      const variantPicker = this.productEl.querySelector('variant-picker');
      if (variantPicker) variantPicker.dataset.updateUrl = 'false';

      const sizeChartModal = this.productEl.querySelector('[data-modal="size-chart"]');
      if (sizeChartModal) sizeChartModal.remove();

      this.updateContent();
      this.updateForm();

      const activeMedia = this.productEl.querySelector('.media-viewer__item.is-current-variant')
        || this.productEl.querySelector('.media-viewer__item');
      if (activeMedia) this.updateMedia(activeMedia.dataset.mediaId);

      if (opener.dataset.selectedColor) {
        setTimeout(this.setActiveVariant.bind(this, opener), 10);
      }
      window.initLazyImages();
    }

    setActiveVariant(opener) {
      const colorOptionBox = this.querySelector(`.opt-btn[value="${opener.dataset.selectedColor}"]`);
      if (colorOptionBox) {
        this.querySelector(`.opt-btn[value="${opener.dataset.selectedColor}"]`).click();
      } else {
        const colorOptionDropdown = this.querySelector(
          `.custom-select__option[data-value="${opener.dataset.selectedColor}"]`
        );
        if (colorOptionDropdown) {
          const customSelect = colorOptionDropdown.closest('custom-select');
          customSelect.selectOption(colorOptionDropdown);
        }
      }
    }

    updateMedia(mediaId) {
      const img = this.productEl.querySelector(`[data-media-id="${mediaId}"] img`);
      if (!img) return;

      const src = img.src ? img.src.split('&width=')[0] : img.dataset.src.split('&width=')[0];
      const container = this.querySelector('.quick-add-info__media');
      if (!container) return;
      const width = container.offsetWidth;
      const aspectRatio = img.width / img.height;

      container.innerHTML = `
        <img src="${src}&width=${width}" srcset="${src}&width=${width}, ${src}&width=${width * 2} 2x" width="${width * 2}" height="${(width * 2) / aspectRatio}" alt="${img.alt}">
      `;
    }

    updateContent() {
      let weightElem = this.getElementHtml('.product-info__weight:not(.product-info__title-weight)');
      if (weightElem && weightElem.length > 0) {
        weightElem = `<div class="product-info__weight text-sm mt-2">${weightElem}</div>`;
      }

      const tiersEl = this.productEl.querySelector('.cw-qty-tiers');
      const tiersHtml = tiersEl ? tiersEl.outerHTML : '';

      this.content.innerHTML = `
        <div class="quick-add-info grid mb-8">
          <div class="quick-add-info__media${theme.settings.blendProductImages ? ' image-blend' : ''}"></div>
          <div class="quick-add-info__details">
            <div class="product-vendor-sku mb-2 text-sm">
              ${this.getElementHtml('.product-vendor-sku')}
            </div>
            <div class="product-title">
              <a class="h6 js-prod-link" href="${this.productUrl}">
                ${this.getElementHtml('.product-title')}
              </a>
            </div>
            ${weightElem}
            <div class="product-price">
              ${this.getElementHtml('.product-price')}
            </div>
            <div class="text-theme-light text-sm mt-4">
              <a href="${this.productUrl}" class="link js-prod-link">
                ${theme.strings.viewDetails}
              </a>
            </div>
          </div>
          <div class="quick-add-info__details md:hidden"></div>
        </div>
        <div class="product-options">
          ${this.getElementHtml('.product-options')}
        </div>
        ${tiersHtml}
        <div class="product-backorder">
          ${this.getElementHtml('.product-backorder')}
        </div>
        <script type="application/json" class="js-inventory-data">
          ${this.getElementHtml('.js-inventory-data')}
        <\/script>
      `;

      this.classList.remove('is-loading');
      this.content.classList.remove('drawer__content--out');

      this.initQuickshopTiers();
    }

    initQuickshopTiers() {
      const tiersEl = this.querySelector('.cw-qty-tiers');
      if (!tiersEl) return;

      const basePrice = parseInt(tiersEl.dataset.basePrice, 10);
      const inventory = parseInt(tiersEl.dataset.inventory, 10) || 0;
      const inventoryPolicy = tiersEl.dataset.inventoryPolicy || '';
      const self = this;

      function formatMoney(cents) {
        const euros = Math.floor(cents / 100);
        const ct = String(cents % 100).padStart(2, '0');
        return '\u20ac\u00a0' + euros + ',' + ct;
      }

      function updateAtcPrice(qty, discount) {
        const unitDiscount = Math.floor(basePrice * discount / 100);
        const unitPrice = basePrice - unitDiscount;
        const total = unitPrice * qty;
        const euros = Math.floor(total / 100);
        const ct = String(total % 100).padStart(2, '0');
        const priceStr = euros + ',' + ct;

        setTimeout(() => {
          const btn = self.form.querySelector('button[name="add"]');
          if (!btn) return;
          let priceSpan = btn.querySelector('.cw-qs-btn-price');
          if (!priceSpan) {
            priceSpan = document.createElement('span');
            priceSpan.className = 'cw-qs-btn-price';
            btn.appendChild(priceSpan);
          }
          priceSpan.textContent = ' \u2022 ' + priceStr;
        }, 50);
      }

      // Markeer uitverkochte tiers
      if (inventoryPolicy !== 'continue' && inventory > 0) {
        tiersEl.querySelectorAll('.cw-qty-tier').forEach((tier) => {
          const qty = parseInt(tier.dataset.qty, 10);
          if (qty > inventory) {
            tier.classList.add('cw-qty-tier--soldout');
            tier.setAttribute('aria-disabled', 'true');
            const saving = tier.querySelector('.cw-qty-tier__saving');
            if (saving) saving.remove();
            const badge = tier.querySelector('.cw-qty-tier__badge');
            if (badge) badge.remove();
            const soldoutBadge = document.createElement('span');
            soldoutBadge.className = 'cw-qty-tier__soldout';
            soldoutBadge.textContent = 'Niet genoeg';
            tier.appendChild(soldoutBadge);
          }
        });
      }

      tiersEl.querySelectorAll('.cw-qty-tier').forEach((tier) => {
        tier.addEventListener('click', function() {
          if (this.classList.contains('cw-qty-tier--soldout')) return;

          const qty = parseInt(this.dataset.qty, 10);
          const discount = parseInt(this.dataset.discount, 10);

          tiersEl.querySelectorAll('.cw-qty-tier').forEach((t) => {
            t.classList.remove('cw-qty-tier--selected');
            t.setAttribute('aria-pressed', 'false');
          });
          this.classList.add('cw-qty-tier--selected');
          this.setAttribute('aria-pressed', 'true');

          const qtyInput = self.querySelector('input[name="quantity"], .qty-input__input');
          if (qtyInput) {
            qtyInput.value = qty;
            qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          const savingsEl = tiersEl.querySelector('.js-cw-tier-savings');
          if (savingsEl) {
            if (discount > 0) {
              const saving = Math.round(basePrice * qty * discount / 100);
              savingsEl.textContent = 'Je bespaart ' + formatMoney(saving) + ' op ' + qty + ' stuks!';
              savingsEl.classList.add('is-visible');
            } else {
              savingsEl.classList.remove('is-visible');
              savingsEl.textContent = '';
            }
          }

          updateAtcPrice(qty, discount);
        });
      });

      setTimeout(() => { updateAtcPrice(1, 0); }, 200);
    }

    updateForm() {
      const productForm = this.productEl.querySelector('product-form');
      this.footer.classList.remove('quick-add__footer-message');

      const newQuickOrderList = this.productEl.querySelector('.js-quick-order-list');
      if (!productForm && newQuickOrderList) {
        this.quickOrderList.innerHTML = newQuickOrderList.innerHTML;
      }
      if (productForm) {
        this.form.innerHTML = productForm.innerHTML;
        this.form.init();

        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      } else if (newQuickOrderList) {
        const script = document.createElement('script');
        script.src = newQuickOrderList.querySelector('script:first-of-type').src;
        document.head.appendChild(script);
        this.footer.hidden = true;
      } else {
        const signUpForm = this.productEl.querySelector('.product-signup');
        if (signUpForm) {
          this.form.innerHTML = signUpForm.innerHTML;
        } else {
          this.footer.classList.add('quick-add__footer-message');
          this.form.innerHTML = `
            <div class="alert quick-add__alert bg-info-bg text-info-text">
              <div class="flex">
                <div>
                  <svg class="icon icon--price_tag" width="32" height="32" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
                    <path fill="currentColor" d="M7.59 1.34a1 1 0 01.7-.29h5.66a1 1 0 011 1v5.66a1 1 0 01-.3.7L7.6 15.5a1 1 0 01-1.42 0L.52 9.83a1 1 0 010-1.42l7.07-7.07zm6.36 6.37l-7.07 7.07-5.66-5.66L8.3 2.05h5.66v5.66z" fill-rule="evenodd"/>
                    <path fill="currentColor" d="M9.7 6.3a1 1 0 101.42-1.42 1 1 0 00-1.41 1.41zM9 7a2 2 0 102.83-2.83A2 2 0 009 7z" fill-rule="evenodd"/>
                  </svg>
                </div>
                <div>
                  <p class="text-h6 font-bold mb-2">${theme.strings.awaitingSale}</p>
                  <a class="link js-prod-link" href="${this.productUrl}">${theme.strings.viewDetails}</a>
                </div>
              </div>
            </div>`;
        }
      }

      this.footer.classList.remove('drawer__footer--out');
    }

    getElementHtml(selector) {
      const el = this.productEl.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    addedToCart() {
      if (this.notification) {
        setTimeout(() => {
          this.notification.hidden = false;
        }, 300);
        setTimeout(() => {
          this.notification.hidden = true;
        }, this.notification.dataset.visibleFor);
      }
    }
  }

  customElements.define('quick-add-drawer', QuickAddDrawer);
}